/**
 * TODO:
 * - [] maybe the children already wrapped by a <Text />
 * - [] create component that unify all status alert,
 * and we can select the status alert type via a prop
 */
import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';

import Icon from 'shopper/components/Icon';

const TYPES = { ICON: 'icon', LEFT_ACCENT: 'left-accent' };

const Warn = ({ children, className, type = TYPES.ICON, ...rest }) => (
  <div
    className={twMerge(
      'flex w-full items-center rounded-2 border border-warning-300 bg-warning-100 p-2 text-warning-500 dark:border-warning-300 dark:bg-warning-100 dark:text-warning-300',
      className
    )}
    {...rest}
  >
    {type === TYPES.ICON && (
      <Icon
        className="mr-2 text-warning-300 dark:text-warning-300"
        name="warning"
      />
    )}
    {children}
  </div>
);

Warn.propTypes = {
  /**
   * Text that will be rendered
   */
  children: PropTypes.node.isRequired,
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  /**
   * Choose the type of warn alert
   */
  type: PropTypes.oneOf(Object.values(TYPES)),
};

export default Warn;
